// React-Screen CLoginScreen ("Benutzer Login") - Strangler Phase 5,
// Klasse C. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle loginscreen.js (aus
// lib/scripts/pos/components/CMP_CLoginScreen.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CLoginScreen.html, gezogen aus
// tests/visual-baseline/01-login.html.
//
// Der Eingangsbildschirm der Kasse - jeder Testfall der Suite laeuft durch
// ihn hindurch, und die Galerie vergleicht ihn als Eintrag 01.
// ENTSCHALT am 23.8.2026: React rendert Kopfknoepfe, beide Eingabefelder,
// den Zehnerblock und das versteckte Fokus-Feld selbst
// (react/widgets.jsx); LYT_loginScreen.xml wird nicht mehr gelesen. Die
// Fokus-Kette bleibt trotzdem die alte, weil die Handles die
// Legacy-Prototypen tragen (CInput/CNumPad) - nachgebaut ist nur das DOM.
//
// Erzeugt CPOS.start als Wurzel: new CLoginScreen("0", "Login"), danach
// setzt der Aufrufer zIndex "1" und haengt spaeter den CScreenSaver als
// weiteres Kind an - beides funktioniert mit der Bridge unveraendert (die
// Wurzel-Styles kommen aus spec.rootStyles, das Legacy-Kind landet hinter
// den - hier nicht vorhandenen - React-Knoten).
import { defineReactScreen } from '../bridge.js';
import { CImage } from '../../components/image.js';
import { CPushButton } from '../../components/pushbutton.js';
import { TextLabel, LabeledInputField, NumPad, Input, verdrahteLabeledInputField } from '../widgets.jsx';

function LoginScreen({ bridge }) {
  const t = bridge.t;

  // Ein Eingabefeld des Login-Schirms: beide sehen gleich aus, nur das
  // PIN-Feld ist ein Passwortfeld und traegt die Zusatzklasse "pin".
  const feld = (typ) => ({
    style: { width: '100%' },
    spaltenStyle: { width: '95%' },
    inputStyle: { position: 'static', margin: 'auto', width: '95%' },
    inputAttributes: typ ? { type: typ } : {},
  });
  const beschriftung = { margin: 'auto 0.1em auto auto', fontSize: '2.8vh' };

  return (
    <>
      <img {...bridge.el('0', 'CImage', { proto: CImage.prototype })} className="CImage"
           src="lib/img/customerlogo.gif"
           style={{ position: 'absolute', top: '-6%', left: '1%', height: '5%' }} />
      {/* helpButton: seit jeher stillgelegt, deshalb auch ohne parameter_0 */}
      <KopfKnopf bridge={bridge} pfad="1" text={t('BUTTONS', 'HELPBOOK')}
                 handler={bridge.help} style={{ position: 'absolute', left: '8%', top: '-6.5%', height: '5%' }} />
      <KopfKnopf bridge={bridge} pfad="2" text={'Kalibrieren'}
                 handler={bridge.calib} param0={bridge.id}
                 style={{ position: 'absolute', left: '15%', top: '-6.5%', height: '5%' }} />

      {/* container */}
      <div {...bridge.el('3', 'CFrame')} className="CFrame" style={{ position: 'absolute' }}>
        <TextLabel bridge={bridge} pfad="3:0" addclass="loginheadertext"
                   text={'Benutzer Login'} />
        <TextLabel bridge={bridge} pfad="3:1" style={{ top: '15%' }}
                   text={t('LABELS', 'LOGIN_TEXT')} />
        <LabeledInputField bridge={bridge} pfad="3:2" label={t('LABELS', 'PERSONAL_NUMBER')}
                           labelStyle={beschriftung} feldSpalteStyle={{ width: '100%' }}
                           feldProps={feld(null)} />
        <LabeledInputField bridge={bridge} pfad="3:3" addclass="pin" label={t('LABELS', 'PIN')}
                           labelStyle={beschriftung} feldSpalteStyle={{ width: '100%' }}
                           feldProps={feld('password')} />
        <NumPad bridge={bridge} pfad="3:4" typ="phone" ok cancel />
      </div>

      {/* infoButton ("i"). Die XML gibt der Beschriftung fontSize/fontFamily/
          fontWeight mit - im DOM steht davon NICHTS, weil
          etc/defaults/LYT_CPushButton.xml properties.caption.styles zu einem
          STRING macht und combine() den nicht mehr durch ein Objekt ersetzt
          (bekannte Eigenheit, s. numpad.js). Hier wird deshalb das
          tatsaechliche Ergebnis nachgebaut: kein style. */}
      <KopfKnopf bridge={bridge} pfad="4" text="i" handler={bridge.info} param0={bridge.id}
                 klasse="" style={{ position: 'absolute', right: '1.5%', bottom: '1.5%',
                                    width: '5%', height: '5%' }} />
      {/* hiddenInput: haelt den Fokus in der Kassa */}
      <Input bridge={bridge} pfad="5"
             style={{ width: '0px', position: 'absolute', bottom: '0px', right: '0px', border: '0px' }}
             attributes={{ onFocus_parameter_0: bridge.id }} />
      {/* Pflanze erkennen (21.9.2026, NEU - keine Legacy-Entsprechung).
          Bewusst ein beschrifteter Kopfknopf neben "Kalibrieren" und NICHT
          ein siebentes Symbol in der Symbolreihe rechts: ein Symbol ohne
          Text muesste erst gelernt werden (Nutzer-Entscheid 21.9.2026).
          Pfad 6 - das letzte Kind. Vorne einfuegen wuerde die Pfade aller
          uebrigen verschieben, und der CScreenSaver haengt sich spaeter als
          Legacy-Kind HINTER die React-Knoten (Bridge-Vertrag 7b). */}
      <KopfKnopf bridge={bridge} pfad="6" text={'Pflanze erkennen'}
                 handler={bridge.pflanzeErkennen} param0={bridge.id}
                 style={{ position: 'absolute', left: '22%', top: '-6.5%', height: '5%',
                          ...(pflanzeKnopfSichtbar() ? {} : { display: 'none' }) }} />
    </>
  );
}

// "Pflanze erkennen" ist pro Kasse per ini.txt einzuschalten
// ("PflanzeErkennen JA"). Fehlt der Schluessel, bleibt der Knopf AUS -
// Nutzer-Entscheid 29.9.2026: auf den Produktivkassen noch ausgeblendet.
// Ausgeblendet per display:none statt weggelassen, damit Pfad 6 und
// nameComponent('6') unveraendert bleiben.
export function pflanzeKnopfSichtbar(envProperties) {
  const env = envProperties || (window.POS && POS.EnvProperties) || {};
  const wert = String(env.PFLANZEERKENNEN || '').trim().toUpperCase();
  return wert === 'JA' || wert === 'YES';
}

// Die drei Knoepfe ausserhalb des Rahmens (Handbuch, Kalibrieren, "i").
function KopfKnopf({ bridge, pfad, text, handler, param0, style, klasse = 'headerbutton' }) {
  return (
    <div {...bridge.widget(pfad, 'CPushButton', {
           events: { onMousedown: handler, onMouseout: true, onMouseup: true },
           attributes: param0 ? { onMousedown_parameter_0: param0 } : {},
           proto: CPushButton.prototype,
         })}
         className={'CPushButton' + (klasse ? ' ' + klasse : '')} style={style}>
      <p {...bridge.el(`${pfad}:0`, 'CCaption')} className={'CCaption ' + text}
         dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
}

export const CLoginScreen = defineReactScreen({
  className: 'CLoginScreen',
  // Der Aufrufer gibt "Login" an den Konstruktor - der Screen wird nur so
  // erzeugt, deshalb steht die Klasse hier fest.
  addclass: 'Login',
  htmlType: 'div',
  Screen: LoginScreen,
  prepare(bridge) {
    bridge.blockCount = 3;
    bridge.indexSessions = 0;
    bridge.POSSessions = Array();
  },
  // Nach dem Mount nur noch VERDRAHTUNG - das DOM steht (React). Die Namen
  // sind dieselben wie in LYT_loginScreen.xml, damit die Methoden unten
  // woertlich die alten bleiben.
  mountLegacy(bridge) {
    bridge.nameComponent('3', 'container');
    bridge.nameComponent('3:2', 'user');
    bridge.nameComponent('3:3', 'pin');
    bridge.nameComponent('3:4', 'numPad');
    bridge.nameComponent('1', 'helpButton');
    bridge.nameComponent('2', 'kalibButton');
    bridge.nameComponent('4', 'infoButton');
    bridge.nameComponent('6', 'pflanzeButton');
    bridge.nameComponent('5', 'hiddenInput');

    const user = verdrahteLabeledInputField(bridge, '3:2');
    const pin = verdrahteLabeledInputField(bridge, '3:3');

    // Personalnummer bestaetigen springt ins PIN-Feld, PIN bestaetigen meldet an.
    user.properties.OKcallback.cls = bridge;
    user.properties.OKcallback.fnc = bridge.jumpNext;
    pin.properties.OKcallback.cls = bridge;
    pin.properties.OKcallback.fnc = bridge.login;

    bridge.components.container.components.numPad.controlFields = [user, pin];

    bridge.components.hiddenInput.onFocus = bridge.restoreFocus;

    window.name = 'POSweb Kassa';

    bridge.initDisplay();
  },
  methods: {
    // Handbuch-Knopf. Er war seit jeher stillgelegt (der Rumpf begann mit
    // `return;`). Seit 23.8.2026 oeffnet er das Benutzerhandbuch - der
    // einzige Knopf der Kassa, der schon immer "Handbuch" hiess und nichts
    // tat. Geoeffnet wird wie beim "i"-Knopf daneben.
    help(bridge) {
      // FEHLER 26.8.2026, vom Nutzer gemeldet ("Klick auf Handbuch macht
      // nichts"): der Knopf tat sehr wohl etwas - das Handbuch ging nur
      // HINTER der Kassenmaske auf. Grund ist die Stapelung:
      //   applicationArea
      //     +- 0   Anmeldebildschirm  z-index 1   <- Handbuch haengte hier
      //     +- 338 Hauptbildschirm    z-index 2
      // Ein Kind des Anmeldebildschirms bleibt damit immer dahinter, ein
      // eigener z-index hilft nicht (der Anmeldebildschirm bildet einen
      // eigenen Stapelkontext).
      // Darum: ist jemand angemeldet, gehoert das Handbuch an den
      // Hauptbildschirm - wie jedes andere Overlay auch.
      var eltern = bridge;
      var sitzung = POS.sessions && POS.sessions.currentSession;
      if (sitzung) {
        var haupt = POS.getComponentById(sitzung);
        if (haupt) eltern = haupt;
      }
      var cmpHilfe = eltern.addChild(CHelpScreen);
      cmpHilfe.draw();
    },
    // "Pflanze erkennen": Ware vor die Kamera halten, und die Kassa
    // schaltet die Produktauswahl auf die passende Warengruppe.
    // Der Knopf sitzt hier, weil hier die Kopfleiste gezeichnet wird -
    // gearbeitet wird im Hauptbildschirm der laufenden Sitzung (dort liegt
    // die Produktauswahl). Dieselbe Weiterreichung wie beim Handbuch.
    pflanzeErkennen() {
      var sitzung = POS.sessions && POS.sessions.currentSession;
      var haupt = sitzung ? POS.getComponentById(sitzung) : null;
      if (!haupt || typeof haupt.pflanzeErkennen != 'function') {
        POS.message.show('Bitte zuerst anmelden.', 'warning', 'OK');
        return;
      }
      haupt.pflanzeErkennen();
    },
    // Touchscreen-Kalibrierung. Bis 26.8.2026 stillgelegt (der Rumpf war
    // `return;`) - und selbst ein Aufruf von execute() haette nichts bewirkt:
    // die Funktion in core/tools-fnc.js ist vollstaendig auskommentiert.
    // Auch etc/scripts/calibrate.sh konnte nie laufen, es schickte an
    // 127.0.0.1:8888/execute - eine Route, die es nicht gibt.
    // Jetzt der direkte Weg: execute.php des Kassenservers startet das
    // gekuerzte Skript, das DISPLAY setzt und eCalib aufruft. Der Server
    // laesst GENAU diesen einen Pfad zu (config.js: ALLOWEDCOMMANDS),
    // alles andere bleibt gesperrt.
    calib() {
      $.ajax({
        url: 'execute.php',
        type: 'POST',
        data: { cmd: '/home/pos/etc/scripts/calibrate.sh' },
        cache: false,
      }).done(function (antwort) {
        // Falls der Server einmal mit 200 und "NOK ..." antwortet.
        if (typeof antwort === 'string' && antwort.indexOf('NOK') === 0)
          POS.message.show('Kalibrierung konnte nicht gestartet werden:\n' +
            antwort.slice(4), 'warning', 'OK');
      }).fail(function (xhr) {
        // HIER landet der Normalfall eines Fehlschlags: der Kassenserver
        // schickt bei "NOK ..." den Status 500, jQuery ruft daher fail().
        // Den GRUND mitzeigen - "geht nicht" allein hilft an der Kassa
        // niemandem (live geprueft: hier steht z.B. "/usr/bin/eCalib: No
        // such file or directory").
        var grund = (xhr && typeof xhr.responseText === 'string')
          ? xhr.responseText.replace(/^NOK\s*/, '').trim() : '';
        POS.message.show('Kalibrierung konnte nicht gestartet werden.' +
          (grund ? '\n' + grund : ''), 'warning', 'OK');
      });
    },
    CVS(bridge, component, parameters) {
      var text = bridge.t('MESSAGES', 'CONF_UPDATE_CVS');
      POS.message.show(text, 'question', 'YESNO', bridge, bridge.doCVS);
    },
    doCVS(bridge, me, result) {
      if (result != 'YES')
        return;

      POS.DataImport.getLastCVS();
    },
    // "i"-Knopf rechts unten -> Kassen-Infoschirm.
    info(bridge) {
      var cmpInfo = bridge.addChild(CInfoMode);
      cmpInfo.draw();
    },
    // OKcallback des Benutzerfeldes.
    jumpNext(bridge) {
      bridge.components.container.components.pin.field.input.setFocus();
    },
    restoreFocus(bridge) {
      bridge.components.container.components.pin.field.input.setFocus();
    },
    // OKcallback des PIN-Feldes: der eigentliche Login.
    login(bridge) {
      if (bridge.blockCount == 0)
        return;

      var user = bridge.components.container.components.user.field.input.properties.attributes.value;
      var pin = bridge.components.container.components.pin.field.input.properties.attributes.value;

      if (user == '' && pin == '')
        return;

      if (user == '0815' && pin == '4711') {
        var Stress = new CStressTest();
        Stress.begin();
        return;
      }

      // SQL-Text ZEICHENGENAU wie im Legacy (Master/Slave-Routing).
      var sql = 'SELECT U_ID, Login, MD5Pass FROM U';
      $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
        var userOK = false;
        var userpassOK = false;
        var text;

        for (var i = 0; i < rows.length; i++) {
          var dbLogin = rows[i].Login;

          if (dbLogin == user) {
            userOK = true;
            var dbMD5Pass = rows[i].MD5Pass;
            var MD5Pin = hex_md5(pin);

            if (dbLogin == user && dbMD5Pass == MD5Pin) {
              userpassOK = true;
              bridge.UID = rows[i].U_ID;

              break;
            }
          }
        }

        if (userpassOK) {
          bridge.pin = pin;
          bridge.components.container.components.user.field.input.gotClear();
          bridge.components.container.components.pin.field.input.gotClear();

          bridge.blockCount = 3;

          if (!POS.sessions.hasOpenSession(bridge.UID))
            bridge.loginType = 'new';
          else
            bridge.loginType = 'id';

          var d = new Date();
          var hours = parseFloat(d.getHours());

          if (typeof POS.EnvProperties.ALARMBEGIN != 'undefined' && typeof POS.EnvProperties.ALARMEND != 'undefined') {
            if (hours > parseFloat(POS.EnvProperties.ALARMBEGIN) || hours < parseFloat(POS.EnvProperties.ALARMEND)) {
              if (bridge.testAlarm()) {
                text = bridge.t('MESSAGES', 'ALARM_DEACTIVATED');
                POS.message.show(text, 'info', 'OK');
                return;
              }
            }
          }

          text = bridge.t('MESSAGES', 'PLEASE_WAIT');
          POS.hourGlass.show(text, bridge, bridge.doLogin);
          return;
        }

        if (!userOK) {
          text = bridge.t('MESSAGES', 'USER_WRONG');
          POS.message.show(text, 'critical', 'OK');

          bridge.blockCount--;
        } else if (userOK && !userpassOK) {
          text = bridge.t('MESSAGES', 'PIN_WRONG');
          POS.message.show(text, 'critical', 'OK');

          bridge.blockCount--;
        }

        if (bridge.blockCount == 0) {
          bridge.blockCount = 3; // Hier soll der Benutzer blockiert werden!
        }
      });
    },
    doLogin(bridge) {
      log.add(4, 'Login', 'Logging in user ' + bridge.UID, '');

      if (bridge.loginType == 'new') {
        POS.sessions.addSession(bridge.UID);
        POS.rights.setUserPropsPIN(bridge.UID, bridge.pin);
      } else if (bridge.loginType == 'id')
        POS.sessions.loadSessionFromId(bridge.UID);
    },
    initDisplay(bridge) {
      var Display = new CDisplay();

      Display.addLine();
      Display.addElement(bridge.t('DISPLAY', 'WELCOME_LINE_1'), 9, 2, 0, 19);
      Display.addLine();
      Display.addElement(bridge.t('DISPLAY', 'WELCOME_LINE_2'), 9, 2, 0, 19);
      Display.out();
    },
    copyImages(bridge) {
      if (typeof POS.copyingImages != 'undefined' && POS.copyingImages) {
        var imagesStatus = new CFileHandler();
        imagesStatus.fileName = '../../paranoia/copystatus';

        if (!imagesStatus.open(false)) {
          var text = bridge.t('MESSAGES', 'COPYING_IMAGES_FINISHED');
          POS.message.show(text, 'info', 'OK');
          POS.copyingImages = false;
          return;
        }

        var cnt = imagesStatus.readAll();
        cnt = float2StringD2(cnt);

        var text = bridge.t('MESSAGES', 'COPYING_IMAGES_1') + ' ' + cnt +
          bridge.t('MESSAGES', 'COPYING_IMAGES_2');
        POS.message.show(text, 'question', 'OK');
      } else {
        var text = bridge.t('MESSAGES', 'CONF_COPY_IMAGES');
        POS.message.show(text, 'question', 'YESNO', bridge, bridge.doCopyImages);
      }
    },
    doCopyImages(bridge, me, result) {
      if (result != 'YES')
        return;

      try {
        $.when(execute('cd /home/pos/paranoia ; python getimages.py &', 'Copying images failed')).done(function (result) {
          if (result) {
            POS.copyingImages = true;
          }
        });
      } catch (e) {
        log.add(3, 'Error', 'Copying images failed', e);
      }
    },
    // Alarmanlage: liest die Statusdateien der Anlage. Seit 22.8.2026 gehen
    // die file://-URLs korrekt durch (CFileHandler.absPath) - vorher lieferte
    // die Pruefung IMMER true und blockierte ab ALARMBEGIN jeden Login.
    testAlarm(bridge) {
      var alarmPath = 'file:///home/pos/src/POSAlarm/';
      var alarmPauseFile = 'alarm_pause';
      var alarmWaitFile = 'alarm_wait';
      var alarmStatusFile = 'alarm_status';

      var fhWait = new CFileHandler();
      fhWait.fileName = alarmPath + alarmWaitFile;
      var fhPause = new CFileHandler();
      fhPause.fileName = alarmPath + alarmPauseFile;
      var fhAlarm = new CFileHandler();
      fhAlarm.fileName = alarmPath + alarmStatusFile;

      if (fhWait.open(false, true) == false) {
        log.add(4, 'Error', 'Das File "' + fhWait.fileName + '" konnte nicht gefunden werden');
        return true;
      }

      if (fhAlarm.open(false, true) == false) {
        log.add(4, 'Error', 'Das File "' + fhAlarm.fileName + '" konnte nicht gefunden werden');
        return true;
      }

      var data = fhWait.readAll().replace(/\r/g, '');
      var dataWait = data.split('\n');

      data = fhAlarm.readAll().replace(/\r/g, '');
      var dataAlarm = data.split('\n');

      if (dataWait[0] == '0' && dataAlarm[0] == '0') {
        log.add(4, 'Info', 'Alarm not activated');
        return false;
      } else {
        fhPause.deleteFile();
        fhPause.open(true, true);
        fhPause.overwrite('1');
      }
      return true;
    },
  },
});
